<template>
  <div>
    {{ title }}
    <el-select
      v-close-on-zoom
      :value="state.check.ids"
      :multiple="true"
      :disabled="readonly"
      class="location-select"
      placeholder="Any location"
      @input="(locationKeys) => updateLocations(locationKeys)"
    >
      <el-option
        v-for="location in availableLocations"
        :key="location.key"
        :label="location.label.en"
        :value="location.key"
      />
    </el-select>
    <el-select
      v-close-on-zoom
      :value="state.check.value"
      :placeholder="placeholder"
      :disabled="readonly"
      class="moulage-select"
      @input="(moulageKey) => updateMoulage(moulageKey)"
    >
      <el-option
        v-for="moulage in availableMoulages"
        :key="moulage.key"
        :label="moulage.label.en"
        :value="moulage.key"
      />
    </el-select>
  </div>
</template>

<script>
import flatten from 'lodash/flatten';
import uniq from 'lodash/uniq';
import keyBy from 'lodash/keyBy';

import moulages from '~lib/common/config/moulages';
import physicalAssessmentLocations from '~lib/common/config/physicalAssessmentLocations';
import structuralMoulageLocations from '~lib/common/config/structuralMoulageLocations';
import physicalToStructural from '~lib/common/config/physicalAssessmentLocationsToStructuralLocations';

export default {
  name: 'moulage-check',
  components: {},
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
    'moulageCategory',
    'placeholder',
    'title',
    'useStructuralLocations'
  ],
  data() {
    return {
      state: {
        check: {
          ids: [],
          value: null,
        },
      },
    };
  },
  computed: {
    availableMoulages() {
      if (!this.moulageCategory) {
        return this.moulages;
      }
      return moulages.filter((m) => m.category === this.moulageCategory);
    },
    availableLocations() {
      const availablePhysicalLocations = uniq(
        flatten(this.availableMoulages.map((moulage) => moulage.locations))
      )
        .map((locationKey) =>
          physicalAssessmentLocations.find((location) => location.key === locationKey)
        )
        .filter((physicalAssessmentLocation) => !!physicalAssessmentLocation);
      if (this.useStructuralLocations) {
        return availablePhysicalLocations
          .map(
            (physicalAssessmentLocation) =>
              physicalToStructural[physicalAssessmentLocation.key]
          )
          .map((structuralMoulageLocationKey) =>
            structuralMoulageLocations.find(
              (structuralMoulageLocation) =>
                structuralMoulageLocation.key === structuralMoulageLocationKey
            )
          )
          .filter((structuralMoulageLocation) => !!structuralMoulageLocation);
      }
      return availablePhysicalLocations;
    },
    moulagesByKey() {
      return keyBy(moulages, 'key');
    },
  },
  mounted() {
    this.state.check = {
      ...this.state.check,
      ...(this.getData(this.ikey) || {}),
    };
    if (!this.state.check.value) {
      this.state.check.value = this.availableMoulages[0]
        ? this.availableMoulages[0].key
        : null;
    }
    this.emitter.trigger('process', this.control);
    this.update();
  },
  methods: {
    updateLocations(locationKeys) {
      this.state.check.ids = locationKeys;
      this.update();
    },
    updateMoulage(moulage) {
      this.state.check.value = moulage;
      this.update();
    },
    update() {
      const selectedMoulage = this.moulagesByKey[this.state.check.value];
      const type =
        selectedMoulage && selectedMoulage.isStructural
          ? 'STRUCTURAL_MOULAGE'
          : 'MOULAGE';
      this.putData(this.ikey, { ...this.state.check, type });
      this.emitter.trigger('process', this.control);
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
</style>
